import { createContext } from 'react';

const sessionState = { session: undefined, setSession: undefined }

export const SessionContext = createContext(sessionState);